import request from '@/utils/request'
const courseApi = {
  queryCourseCategoryList: () => {
    return request({
      url: '/public/course/category/list',
      method: 'get'
    })
  },
  queryCourseCategoryInfo: (categoryId) => {
    return request({
      url: '/public/course/category/info/' + categoryId,
      method: 'get'
    })
  },
  queryCourseList: (params) => {
    return request({
      url: '/public/course/list',
      method: 'get',
      params
    })
  }
}

export default courseApi
